import React from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../components/PublicHeader';

export default function TermsPage() {
  return (
    <div className="landing">
      <PublicHeader />

      <main className="privacy-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: March 2026</p>

        <h2>Acceptance of terms</h2>
        <p>
          By creating an account or using The Email Helper, you agree to these Terms of Service.
          If you do not agree, do not use the service. We may update these terms from time to time;
          continued use after changes are posted constitutes acceptance of the updated terms.
        </p>

        <h2>The service</h2>
        <p>
          The Email Helper is an inbox management tool that connects to your email account to
          detect subscriptions, archive emails, and surface organisational insights. The service
          is operated by Oblivion Solutions Limited, a company registered in England and Wales.
        </p>
        <p>
          We provide the service on a best-efforts basis. We do not guarantee uninterrupted
          availability and may modify or discontinue features at any time.
        </p>

        <h2>Your account</h2>
        <p>
          You must sign in with a valid Google or Microsoft account to use the service. You are
          responsible for all activity that occurs under your account. You must not use the
          service for any unlawful purpose or in any way that could harm other users or the
          integrity of the service.
        </p>

        <h2>Data and privacy</h2>
        <p>
          By connecting your email account, you grant us permission to access your email metadata
          (sender, subject, date, and headers) for the purpose of providing the service. We do
          not read or store full email bodies, and we do not sell your data. For full details,
          see our <Link to="/privacy">Privacy Policy</Link>.
        </p>

        <h2>Account termination</h2>
        <p>
          You may stop using the service and disconnect your account at any time from the Settings
          page. We reserve the right to suspend or terminate accounts that violate these terms,
          engage in abuse, or have been inactive for an extended period, with or without notice.
        </p>
        <p>
          On termination, your stored email metadata and OAuth tokens will be deleted.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          The service is provided "as is" without warranties of any kind. To the fullest extent
          permitted by law, Oblivion Solutions Limited shall not be liable for any indirect,
          incidental, or consequential damages arising from your use of the service, including
          any loss of data or unintended changes to your email account resulting from actions
          you take within the app.
        </p>

        <h2>Governing law</h2>
        <p>
          These terms are governed by the laws of England and Wales. Any disputes shall be
          subject to the exclusive jurisdiction of the courts of England and Wales.
        </p>

        <h2>Contact</h2>
        <p>
          For questions about these terms, contact us at{' '}
          <a href="mailto:legal@theemailhelper.com">legal@theemailhelper.com</a>.
        </p>
      </main>

      <footer className="landing-footer">
        © {new Date().getFullYear()} Oblivion Solutions Limited ·{' '}
        <Link to="/privacy">Privacy</Link> ·{' '}
        <Link to="/terms">Terms</Link>
      </footer>
    </div>
  );
}
